(function () {
  angular
    .module("akitabox.workOrder.create")
    .controller("CreateWorkOrderController", CreateWorkOrderController);

  /* @ngInject */
  function CreateWorkOrderController(
    // Angular
    $q,
    $scope,
    $timeout,
    // Third party
    $state,
    moment,
    // Services
    AssetService,
    FloorService,
    InspectionService,
    IssueTypeService,
    PinValueService,
    RequestService,
    RoomService,
    TimeZoneService,
    TradeService,
    ToastService,
    TypeService,
    UserService,
    WorkOrderService,
    ChecklistTemplateService,
    OrganizationService,
    // Models
    account,
    building,
    // Route params
    floorId,
    roomId,
    assetId,
    requestId,
    // Constants
    PRIORITIES,
    INTENT_ISSUE_TYPE,
    INTENT_MAINTENANCE_TYPE
  ) {
    var self = this;

    self.organization = OrganizationService.getCurrent();
    self.showChecklists = self.organization.show_inspections;
    self.multiLocationEnabled = self.organization.show_inspections;

    // Locations for the updated WO dialog

    self.locations = [
      {
        floor: null,
        room: null,
        asset: null,
      },
    ];

    var collection = {
      trades: null,
      types: null,
      checklists: null,
    };
    var tradeRequest;
    var typeRequest;
    var checklistRequest;

    // Attributes
    self.utcOffset = TimeZoneService.getCurrentUTCOffset();
    self.timeZone = TimeZoneService.getCurrentTimeZone();
    self.saving = false;
    self.successful = false;
    self.activeTab = 0;
    self.tabs = null;

    // Location tab variables
    self.account = account;
    self.building = building;
    self.buildingAccount = null;
    self.request = null;

    self.floor = null;
    self.room = null;
    self.asset = null;

    self.attachments = [];

    // Details tab variables
    self.subject = null;
    self.description = null;

    var nowMoment = moment();
    if (self.utcOffset) {
      nowMoment.utcOffset(self.utcOffset);
    }
    var startMoment = nowMoment.clone().startOf("day");
    self.today = startMoment.toDate();
    self.startDate = self.today;
    // save originalStartDate for when startDate changes
    self.originalStartDate = self.startDate;
    self.dueDate = startMoment.clone().add(1, "days").toDate();
    self.minDueDate = startMoment.toDate();
    self.dueDateOpen = false;
    self.estimatedManHours = 1;
    self.checklist = null;

    // Assign tab variables
    self.PRIORITIES = PRIORITIES;
    self.priority = "medium";
    self.trade = null;
    self.type = null;
    self.loading = {
      assignee: false,
      trade: false,
    };
    self.classes = {
      root: "",
      item: "no-padding inherit-color",
    };
    self.assignees = [];
    self.assigneesPopulatedByTrade = false;
    self.locationIsDuplicated = false;

    // Navigation Functions
    self.next = next;
    self.previous = previous;
    self.selectTab = selectTab;
    self.isComplete = isComplete;

    // Location Tab Functions
    self.handleFileChange = handleFileChange;
    self.allUploadComplete = allUploadComplete;
    self.handleAddLocationClick = handleAddLocationClick;
    self.handleRemoveLocationClick = handleRemoveLocationClick;
    self.hasValidLocations = hasValidLocations;

    // Details Tab Functions
    self.onStartDateChange = onStartDateChange;

    // Assignee Tab Functions
    self.searchTrades = searchTrades;
    self.searchTypes = searchTypes;
    self.searchChecklists = searchChecklists;
    self.createWorkOrder = createWorkOrder;
    self.onTradeChange = onTradeChange;
    self.onTypeChange = onTypeChange;
    self.onAssigneesChange = onAssigneesChange;

    init();

    // ------------------------
    //   Private Functions
    // ------------------------

    function init() {
      // Clear assignee when building changes
      $scope.$watch("vm.building", function (building) {
        if (building) {
          self.buildingAccount = building.cre_account;
          self.showTypeDropdown =
            building.show_issue_types || building.show_maintenance_types;
        }
        self.trade = null;
        self.type = null;
        // the assignees will do the same, but it's controlled by the directive
      });

      /**
       * Seems to be no other solution to actively watch this without setting objectEquality -> true
       * We can wait until they click "Create" to tell them they have duplicate locations, but it seems
       * too late already by that point. Also using $watchCollection here seems to not work with an array
       * of objects, since it only compares the objects inside of an array via shallow comparison
       */
      $scope.$watch(
        "vm.locations",
        function (watchedLocations) {
          if (!watchedLocations || watchedLocations.length <= 1)
            return (self.locationIsDuplicated = false);

          var hasDuplicates = false;
          var duplicateLocations = {};
          for (var i = 0; i < watchedLocations.length; i++) {
            var watchedLocation = watchedLocations[i];
            var watchedAsset = watchedLocation.asset
              ? watchedLocation.asset._id
              : "_";
            var watchedFloor = watchedLocation.floor
              ? watchedLocation.floor._id
              : "_";
            var watchedRoom = watchedLocation.room
              ? watchedLocation.room._id
              : "_";
            var hash = watchedAsset + watchedFloor + watchedRoom;
            if (duplicateLocations[hash]) {
              // if we already have this location, mark it as duplicated
              self.locations[i].duplicated = true;
              hasDuplicates = true;
            } else {
              // otherwise, allow blank locations or add the new unique location
              // to our map for tracking
              if (hash === "___") {
                continue;
              }

              duplicateLocations[hash] = [i];
              self.locations[i].duplicated = false;
            }
          }
          self.locationIsDuplicated = hasDuplicates;
        },
        true
      );

      // Handle any URL parameters that were passed in
      // so we can autofill the fields.
      // Building is required to autofill any query param
      if (angular.isEmpty(self.building)) {
        self.tabs = getTabs();
        return;
      }

      var floorPinValue;
      var roomPinValue;
      if (!angular.isEmpty(requestId)) {
        RequestService.getById(building._id, requestId)
          .then(function (request) {
            // if multiLocationEnabled, set self.locations
            if (self.multiLocationEnabled) {
              if (request.asset) {
                if (request.level) request.asset.level = request.level;
                if (request.room) request.asset.room = request.room;
              }

              if (request.room && request.level)
                request.room.level = request.level;

              self.locations[0].floor = request.level;

              self.locations[0].room = request.room;
              if (self.locations[0].room)
                self.locations[0].room.level = request.level;

              self.locations[0].asset = request.asset;
              if (self.locations[0].asset) {
                self.locations[0].asset.room = request.room;
                self.locations[0].asset.level = request.level;
              }
            } else {
              // multiLocationEnabled is false, set legacy location fields

              if (request.asset) {
                if (request.level) request.asset.level = request.level;
                if (request.room) request.asset.room = request.room;
              }

              if (request.room && request.level)
                request.room.level = request.level;

              self.floor = request.level;

              self.room = request.room;
              if (self.room) self.room.level = request.level;

              self.asset = request.asset;
              if (self.asset) {
                self.asset.room = request.room;
                self.asset.level = request.level;
              }
            }
            // Make sure the locations know of each other before settings them

            self.subject = request.subject;
            self.description = request.description;
            self.type = request.issue_type;
            self.request = request;
            self.showTypeDropdown = self.building.show_issue_types;
          })
          .then(function () {
            // Retrieve tabs only AFTER populating all location fields
            self.tabs = getTabs();
          })
          .catch(ToastService.showError);
      } else if (!angular.isEmpty(assetId)) {
        AssetService.getById(building._id, assetId, { include_values: true })
          .then(function (asset) {
            // if multiLocationEnabled, set self.locations
            if (self.multiLocationEnabled) {
              // Just grab the name and ID of the floor and room, since that's all we need.
              // This way, we don't need to make another request since they're in the asset's
              // included values
              floorPinValue = PinValueService.getFloorPinValue(asset.values);
              if (floorPinValue && !angular.isEmpty(floorPinValue.value)) {
                self.locations[0].floor = {
                  _id: floorPinValue.value,
                  name: floorPinValue.name,
                };
              }
              roomPinValue = PinValueService.getRoomPinValue(asset.values);
              if (roomPinValue && !angular.isEmpty(roomPinValue.value)) {
                self.locations[0].room = {
                  _id: roomPinValue.value,
                  name: roomPinValue.name,
                };
              }

              self.locations[0].asset = asset;
            } else {
              // Just grab the name and ID of the floor and room, since that's all we need.
              // This way, we don't need to make another request since they're in the asset's
              // included values
              floorPinValue = PinValueService.getFloorPinValue(asset.values);
              if (floorPinValue && !angular.isEmpty(floorPinValue.value)) {
                self.floor = {
                  _id: floorPinValue.value,
                  name: floorPinValue.name,
                };
              }
              roomPinValue = PinValueService.getRoomPinValue(asset.values);
              if (roomPinValue && !angular.isEmpty(roomPinValue.value)) {
                self.room = {
                  _id: roomPinValue.value,
                  name: roomPinValue.name,
                };
              }

              self.asset = asset;
            }
          })
          .then(function () {
            self.tabs = getTabs();
          })
          .catch(ToastService.showError);
      } else if (!angular.isEmpty(roomId)) {
        RoomService.getById(building._id, roomId, { include_values: true })
          .then(function (room) {
            // if multiLocationEnabled, set self.locations
            if (self.multiLocationEnabled) {
              // Just grab the name and ID of the floor, since that's all we need.
              // This way, we don't need to make another request since it's in the room's
              // included values
              floorPinValue = PinValueService.getFloorPinValue(room.values);
              if (floorPinValue && !angular.isEmpty(floorPinValue.value)) {
                self.locations[0].floor = {
                  _id: floorPinValue.value,
                  name: floorPinValue.name,
                };
              }

              self.locations[0].room = room;
            } else {
              // Just grab the name and ID of the floor, since that's all we need.
              // This way, we don't need to make another request since it's in the room's
              // included values
              floorPinValue = PinValueService.getFloorPinValue(room.values);
              if (floorPinValue && !angular.isEmpty(floorPinValue.value)) {
                self.floor = {
                  _id: floorPinValue.value,
                  name: floorPinValue.name,
                };
              }

              self.room = room;
            }
          })
          .then(function () {
            self.tabs = getTabs();
          })
          .catch(ToastService.showError);
      } else if (!angular.isEmpty(floorId)) {
        FloorService.getById(building._id, floorId)
          .then(function (floor) {
            if (self.multiLocationEnabled) {
              self.locations[0].floor = floor;
            } else {
              self.floor = floor;
            }
          })
          .then(function () {
            self.tabs = getTabs;
          })
          .catch(ToastService.showError);
      } else {
        self.tabs = getTabs();
      }
    }

    function getTabs() {
      return [
        {
          title: "Location",
          complete: isLocationComplete,
          disabled: isLocationDisabled,
          template: "app/mobile/modules/work-order/create/tabs/location.html",
        },
        {
          title: "Details",
          complete: isDetailsComplete,
          disabled: isDetailsDisabled,
          template: "app/mobile/modules/work-order/create/tabs/details.html",
        },
        {
          title: "Assign",
          complete: isAssignComplete,
          disabled: isAssignDisabled,
          template: "app/mobile/modules/work-order/create/tabs/assign.html",
        },
      ];
    }

    function isLocationComplete() {
      return self.building !== null && !self.locationIsDuplicated;
    }

    function isLocationDisabled() {
      return false;
    }

    function isDetailsComplete() {
      if (!isLocationComplete()) {
        return false;
      } else if (angular.isEmpty(self.subject)) {
        return false;
      } else if (
        !angular.isDate(self.dueDate) ||
        (angular.isDate(self.dueDate) && self.dueDate.getTime() <= Date.now())
      ) {
        return false;
      } else if (
        !angular.isNumber(self.estimatedManHours) ||
        (angular.isNumber(self.estimatedManHours) &&
          self.estimatedManHours <= 0)
      ) {
        return false;
      }

      return true;
    }

    function isDetailsDisabled() {
      return !isLocationComplete();
    }

    function isAssignComplete() {
      if (!isLocationComplete() || !isDetailsComplete()) {
        return false;
      } else if (
        angular.isEmpty(self.priority) ||
        (self.building.require_trades && angular.isEmpty(self.trade)) ||
        (self.building.require_issue_types &&
          self.building.require_maintenance_types &&
          angular.isEmpty(self.type))
      ) {
        return false;
      }

      return true;
    }

    function isAssignDisabled() {
      return !isDetailsComplete();
    }

    // ------------------------
    //   Public Functions
    // ------------------------

    function next() {
      if (self.activeTab === 2) return;
      self.selectTab(self.activeTab + 1);
    }

    function previous() {
      if (self.activeTab === 0) return;
      self.selectTab(self.activeTab - 1);
    }

    function selectTab(idx) {
      self.activeTab = idx;
    }

    function isComplete() {
      var complete = true;
      angular.forEach(self.tabs, function (tab) {
        complete = complete && tab.complete();
      });
      return complete;
    }

    function createWorkOrder($event) {
      if (self.saving || self.successful) {
        if ($event) $event.preventDefault();
        return;
      }

      self.saving = true;

      var data = {
        subject: self.subject,
        priority: self.priority,
        estimated_man_hr: self.estimatedManHours,
        start_date: self.startDate.getTime(),
        due_date: self.dueDate.getTime(),
        description_text: self.description,
        building: self.building._id,
      };

      data.assignee_users = self.assignees.map(function (assignee) {
        return assignee._id;
      });

      if (self.multiLocationEnabled) {
        data.round = [];

        for (var i = 0; i < self.locations.length; i++) {
          var location = self.locations[i];
          if (location.asset) data.round.push({ asset: location.asset });
          else if (location.room) data.round.push({ room: location.room });
          else if (location.floor) data.round.push({ level: location.floor });
        }
      } else {
        data.round = [];
        if (self.asset) {
          data.round.push({ asset: self.asset._id });
        } else if (self.room) {
          data.round.push({ room: self.room._id });
        } else if (self.floor) {
          data.round.push({ level: self.floor._id });
        }
      }

      if (!angular.isEmpty(requestId)) data.request = requestId;

      if (!angular.isEmpty(self.trade)) data.trade = self.trade._id;

      if (!angular.isEmpty(self.attachments)) {
        data.attachments = self.attachments.map(function (attachment) {
          return attachment._document._id;
        });
      }

      if (!angular.isEmpty(self.checklist)) {
        data.checklist_template = self.checklist._id;
      }

      // Set issue_type or maintenance type
      // based on the selected type's intent
      if (!angular.isEmpty(self.type)) {
        var intent = self.type.intent;
        if (intent === INTENT_MAINTENANCE_TYPE) {
          data.maintenance_type = self.type._id;
        } else if (intent === INTENT_ISSUE_TYPE) {
          data.issue_type = self.type._id;
        }
      }

      // If a checklist has been selected, then POST to /inspections instead
      // of /tasks to create an inspection, task, and checklists
      if (data.checklist_template) {
        return InspectionService.create(self.organization._id, data)
          .then(function (workOrder) {
            self.saving = false;
            self.successful = true;
            return $timeout(function () {
              return workOrder;
            }, 500);
          })
          .then(function (workOrder) {
            $state.go("app.building.workOrder.detail", {
              buildingId: self.building._id,
              workOrderId: workOrder._id,
              workOrder: workOrder,
            });
          })
          .catch(function (err) {
            self.saving = false;
            ToastService.showError(err);
          });
      } else {
        // we must pass in timeZone because the building context is not available
        // when `WorkOrderService.create` is executed
        return WorkOrderService.create(self.building._id, data, self.timeZone)
          .then(function (workOrder) {
            self.saving = false;
            self.successful = true;
            return $timeout(function () {
              return workOrder;
            }, 500);
          })
          .then(function (workOrder) {
            $state.go("app.building.workOrder.detail", {
              buildingId: self.building._id,
              workOrderId: workOrder._id,
              workOrder: workOrder,
            });
          })
          .catch(function (err) {
            self.saving = false;
            ToastService.showError(err);
          });
      }
    }

    function searchTypes(query) {
      self.typeQuery = query;
      var getTypes;
      if (
        self.building &&
        (self.building.show_issue_types || self.building.show_maintenance_types)
      ) {
        // Check if we already have all the types or
        // if there's an outstanding request for them
        if (collection.types && collection.types.length) {
          return filterCollection(collection.types, self.tradeQuery, "name");
        }

        if (typeRequest) {
          return typeRequest;
        }

        // if from a service request, only get issue types
        if (self.request && self.building.show_issue_types) {
          getTypes = IssueTypeService.getAll(self.building._id);
        } else {
          // if standalone, fetch all issue types and maintenance types
          getTypes = TypeService.getTypes(self.building);
        }

        typeRequest = getTypes
          .then(function (types) {
            collection.types = types;
            return filterCollection(collection.types, self.typeQuery, "name");
          })
          .catch(function (err) {
            ToastService.showError(err);
            collection.types = [];
            return $q.reject(err);
          })
          .finally(function () {
            typeRequest = null;
          });
        return typeRequest;
      }
      return [];
    }

    function searchTrades(query) {
      self.tradeQuery = query;
      if (self.building && self.building.show_trades) {
        // Check if we already have all the trades or
        // if there's an outstanding request for them
        if (collection.trades && collection.trades.length) {
          return filterCollection(collection.trades, self.tradeQuery, "name");
        }
        if (tradeRequest) {
          return tradeRequest;
        }
        // Fetch all trades
        tradeRequest = TradeService.getAll(self.building._id)
          .then(function (trades) {
            collection.trades = trades;
            return filterCollection(collection.trades, self.tradeQuery, "name");
          })
          .catch(function (err) {
            ToastService.showError(err);
            collection.trades = [];
            return $q.reject(err);
          })
          .finally(function () {
            tradeRequest = null;
          });
        return tradeRequest;
      }
      return [];
    }

    function searchChecklists(query) {
      self.checklistQuery = query;
      if (self.showChecklists) {
        // Check if we already have all the checklists or
        // if there's an outstanding request for them
        if (collection.checklists && collection.checklists.length) {
          return filterCollection(
            collection.checklists,
            self.checklistQuery,
            "name"
          );
        }

        if (checklistRequest) {
          return checklistRequest;
        }
        var params = {};

        // Fetch all checklust templates
        checklistRequest = ChecklistTemplateService.getAll(
          self.organization._id,
          params
        )
          .then(function (checklists) {
            collection.checklists = checklists;
            return filterCollection(
              collection.checklists,
              self.checklistQuery,
              "name"
            );
          })
          .catch(function (err) {
            ToastService.showError(err);
            collection.checklists = [];
            return $q.reject(err);
          })
          .finally(function () {
            checklistRequest = null;
          });
        return checklistRequest;
      }
    }

    function onTradeChange(trade) {
      // Don't try to default the assignees if they were already handpicked by the user
      if (self.assignees.length && !self.assigneesPopulatedByTrade) return;

      // Set default assignee
      if (trade && trade.default_assignee_user) {
        UserService.get(self.building.organization, {
          _id: trade.default_assignee_user,
          buildings: self.building._id,
        })
          .then(function (user) {
            // since we provided _id in the query, http.service.get() will not return an array
            self.assignees = user ? [user] : [];
            self.assigneesPopulatedByTrade = true;
          })
          .catch(ToastService.showError);
      }
    }

    function onTypeChange(type) {
      if (self.trade) return;

      // Set default trade
      if (type && type.trade && self.building.show_trades) {
        self.loading.trade = true;
        if (collection.trades) {
          for (var i = 0; i < collection.trades.length; ++i) {
            if (type.trade === collection.trades[i]) {
              self.trade = collection.trades[i];
              self.loading.trade = false;
              return;
            }
          }
        }
        TradeService.getById(self.building._id, type.trade)
          .then(function (trade) {
            self.trade = trade;
          })
          .catch(ToastService.showError)
          .finally(function () {
            self.loading.trade = false;
          });
      }
    }

    /**
     * Update due date and minimum due date when the start date changes
     */
    function onStartDateChange() {
      if (self.startDate > self.dueDate) {
        // keep previous duration between start and due date
        var difference = moment(self.dueDate).diff(
          moment(self.originalStartDate),
          "days"
        );
        self.dueDate = moment(self.startDate).add(difference, "days").toDate();
      }
      if (self.startDate > self.today) {
        // prevent selecting a dueDate before startDate
        self.minDueDate = self.startDate;
      } else {
        // prevent selecting a dueDate before today if startDate is in the past
        self.minDueDate = self.today;
      }

      // update originalStartDate to contain the new startDate
      self.originalStartDate = self.startDate;
    }

    /**
     * Check if self.locations contains as least one valid location
     */
    function hasValidLocations() {
      for (var i = 0; i < self.locations.length; i++) {
        var location = self.locations[i];
        if (location.room || location.asset || location.floor) {
          return true;
        }
      }
      return false;
    }

    /**
     * Filter a collection (list) with a search query
     *
     * @param  {Array}  collection  Collection of options
     * @param  {String} query       Search query text
     * @param  {String} key         [Optional] key to match on
     *
     * @return {Array}              Query matches
     */
    function filterCollection(collection, query, key) {
      if (angular.isEmpty(query)) return collection;
      var matchExp = new RegExp(query, "i");
      return collection.filter(function (item) {
        var value = key ? item[key] : item;
        return value.match(matchExp);
      });
    }

    function handleFileChange(files) {
      self.attachments = files;
    }

    function allUploadComplete() {
      return self.attachments.reduce(function (prev, current) {
        return prev && current.complete;
      }, true);
    }

    function handleAddLocationClick() {
      self.locations.push({
        floor: null,
        room: null,
        asset: null,
      });
    }

    function handleRemoveLocationClick(location) {
      if (self.locations.length > 1) {
        var indexToRemove = self.locations.indexOf(location);
        self.locations.splice(indexToRemove, 1);
      } else {
        self.locations = [{}];
      }
    }
    /**
     * Updates the dialog's assignees every time it changes within the
     * multiple-assignees-input
     *
     * @param {object} event
     * @param {Array<User>} event.value - the assignees currently in the input
     */
    function onAssigneesChange(event) {
      self.assigneesPopulatedByTrade = false;
      self.assignees = event.value;
    }
  }
})();
